export default __webpack_public_path__ + "static/media/a024-startup-5.489b8e52.svg";